import { TableItem, Text, HStack, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { messageError } from '../../../Statements/Table/constants';
import { marginRequiredWidthCols } from '../TableHead/constants';

interface MarginRequiredItemProps {}

export const MarginRequiredItem: React.FC<MarginRequiredItemProps> = () => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const isTablet = useBreakpointValue({ base: false, sm: true, lg: false });

  const marginRequiredDate = '28/05/2023';
  const marginRequiredType = 'JUROS';
  const marginWarranty = messageError;
  const marginBalance = 'R$ 46,00';

  if (isMobile) {
    return (
      <VStack alignItems="center" justifyContent="space-between" space={Spacing['inline.nano']}>
        <HStack alignItems="center" justifyContent="space-between" w="full">
          <Text color="neutral.dark" fontSize={Typography['fontsize.md']}>
            Data
          </Text>
          <Text color="neutral.dark" fontSize={Typography['fontsize.md']}>
            {marginRequiredDate}
          </Text>
        </HStack>
        <HStack alignItems="center" justifyContent="space-between" w="full">
          <Text color="neutral.dark" fontSize={Typography['fontsize.md']}>
            Requerido
          </Text>
          <Text color="neutral.dark" fontSize={Typography['fontsize.md']}>
            {marginRequiredType}
          </Text>
        </HStack>
        <HStack alignItems="center" justifyContent="space-between" w="full">
          <Text color="neutral.dark" fontSize={Typography['fontsize.md']}>
            Garantia
          </Text>
          <Text color="neutral.dark" fontSize={Typography['fontsize.md']}>
            {marginWarranty}
          </Text>
        </HStack>
        <HStack alignItems="center" justifyContent="space-between" w="full">
          <Text color="neutral.dark" fontSize={Typography['fontsize.md']}>
            Saldo
          </Text>
          <Text color="neutral.dark" fontSize={Typography['fontsize.md']}>
            {marginBalance}
          </Text>
        </HStack>
      </VStack>
    );
  }

  if (isTablet) {
    return (
      <HStack
        alignItems="center"
        justifyContent="space-between"
        w="full"
        mb={Spacing['stack.xxxs']}>
        <VStack space={Spacing['inline.quarck']}>
          <Text variant="semibold" color="neutral.black" fontSize={Typography['fontsize.md']}>
            Data
          </Text>
          <Text variant="regular" color="neutral.dark" fontSize={Typography['fontsize.md']}>
            {marginRequiredDate}
          </Text>
        </VStack>
        <VStack space={Spacing['inline.quarck']}>
          <Text variant="semibold" color="neutral.black" fontSize={Typography['fontsize.md']}>
            Requerido
          </Text>
          <Text variant="regular" color="neutral.dark" fontSize={Typography['fontsize.md']}>
            {marginRequiredType}
          </Text>
        </VStack>
        <VStack space={Spacing['inline.quarck']}>
          <Text variant="semibold" color="neutral.black" fontSize={Typography['fontsize.md']}>
            Garantia
          </Text>
          <Text variant="regular" color="neutral.dark" fontSize={Typography['fontsize.md']}>
            {marginWarranty}
          </Text>
        </VStack>
        <VStack space={Spacing['inline.quarck']}>
          <Text variant="semibold" color="neutral.black" fontSize={Typography['fontsize.md']}>
            Saldo
          </Text>
          <Text variant="regular" color="neutral.dark" fontSize={Typography['fontsize.md']}>
            {marginBalance}
          </Text>
        </VStack>
      </HStack>
    );
  }

  return (
    <HStack alignItems="center">
      <TableItem
        testId="margin-required-date-item"
        width={marginRequiredWidthCols.marginRequiredDate.desktop}>
        <Text
          fontSize={Typography['fontsize.xs']}
          noOfLines={1}
          color="neutral.black"
          variant="regular">
          {marginRequiredDate}
        </Text>
      </TableItem>
      <TableItem
        testId="margin-required-type-item"
        width={marginRequiredWidthCols.marginRequiredType.desktop}>
        <Text
          fontSize={Typography['fontsize.xs']}
          noOfLines={1}
          color="neutral.black"
          variant="regular">
          {marginRequiredType}
        </Text>
      </TableItem>
      <TableItem
        testId="margin-warranty-item"
        width={marginRequiredWidthCols.marginWarranty.desktop}>
        <Text
          fontSize={Typography['fontsize.xs']}
          noOfLines={1}
          color="neutral.black"
          variant="regular">
          {marginWarranty}
        </Text>
      </TableItem>
      <TableItem testId="margin-balance-item" width={marginRequiredWidthCols.marginBalance.desktop}>
        <Text
          fontSize={Typography['fontsize.xs']}
          noOfLines={1}
          color="neutral.black"
          variant="regular">
          {marginBalance}
        </Text>
      </TableItem>
    </HStack>
  );
};
